import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

var FONT_COLOR_DARK = "#333";
var FONT_COLOR_LIGHT = "#fff";
var colorsMore = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-status{display:inline-block;word-break:break-all;min-height:22px;min-width:68px;padding:0 8px;margin:0 2px;vertical-align:bottom;font-size:12px;font-weight:700;line-height:18px;text-align:center;color:#000;background-color:#ccc;border:2px solid #ccc;border-radius:2px;cursor:text}.ct-status[data-color=red]{background-color:#f5222d;border-color:#f5222d}.ct-status[data-color=red][data-pattern=fill]{color:#fff}.ct-status[data-color=yellow]{background-color:#fadb14;border-color:#fadb14}.ct-status[data-color=yellow][data-pattern=fill]{color:#876800}.ct-status[data-color=green]{background-color:#52c41a;border-color:#52c41a}.ct-status[data-color=green][data-pattern=fill]{color:#fff}.ct-status[data-color=blue]{background-color:#1890ff;border-color:#1890ff}.ct-status[data-color=blue][data-pattern=fill]{color:#fff}.ct-status[data-pattern=outline]{background-color:#f7f7f7}.ct-status.ProseMirror-selectednode{outline:unset}.ct-status.ct-selected,.ct-status.ProseMirror-selectednode,.ct-status:hover{position:relative}.ct-status.ct-selected:after,.ct-status.ProseMirror-selectednode:after,.ct-status:hover:after{z-index:2;position:absolute;content:"";left:-3px;right:-3px;top:-3px;bottom:-3px;border:2px solid #23bdd9;border-radius:3px;pointer-events:none}.ct-status[data-selectedkey]{cursor:default}.ProseMirror-selectednode .ct-status{outline:2px solid #0082a6}.ProseMirror-widget+span.ct-status{top:auto}';
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var computeFontColor = function(color) {
    var index = colorsMore.findIndex(function(c) {
        return c === color;
    });
    if (index === -1) {
        return FONT_COLOR_DARK;
    }
    if (index % 12 < 1) {
        return FONT_COLOR_DARK;
    }
    if (index % 12 < 2) {
        return FONT_COLOR_LIGHT;
    }
    if (index > 11 && index < 36) {
        return FONT_COLOR_DARK;
    }
    return FONT_COLOR_LIGHT;
};
var computeStyle = function(color, pattern) {
    return "\n    background: ".concat(pattern === "fill" ? color : "#fff", ";\n    border-color: ").concat(color, ";\n    color: ").concat(pattern === "fill" ? computeFontColor(color) : "", ";\n  ");
};
var statusRender = function statusRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, statusRender);
    this.fragmentRender = function(node) {
        var _node_dataset = node.dataset, _node_dataset_color = _node_dataset.color, color = _node_dataset_color === void 0 ? "#ccc" : _node_dataset_color, _node_dataset_pattern = _node_dataset.pattern, pattern = _node_dataset_pattern === void 0 ? "fill" : _node_dataset_pattern;
        node.setAttribute("style", computeStyle(color, pattern));
    };
    this.fragmentCls = ".".concat(classNamePrefix("status"));
    this.config = config;
};

export default statusRender;
//# sourceMappingURL=render.js.map
